var crosspointCustomerFormId = '#RegisterForm'; 


var CROSSPOINT_LOGIN_COMPLETE_PATH = '/pages/mypage';


var CROSSPOINT_CUSTOMER_ACCOUNT_HOSTS = [
  'shopify.com'
  //, 'account.example.com'
];

// ---------------- cookie関連 start----------------
(function () {
  if (window.Store) {
    return;
  }

  var STORAGE_BACKEND = 'storage'; // 'storage' | 'cookie'
  var USE_SESSION = true;          // true: sessionStorage / session cookie
                                   // false: localStorage / persistent cookie

  var storage = USE_SESSION ? sessionStorage : localStorage;

  function setCookie(key, val) {
    var opts = [];

    if (!USE_SESSION) {
      var maxAge = 60 * 60 * 24 * 30;
      opts.push('max-age=' + maxAge);
    }

    document.cookie = encodeURIComponent(key) + '=' + encodeURIComponent(val) + '; path=/; ' + opts.join(';');
  }

  function getCookie(key) {
    var escapedKey = key.replace(/[-.+*]/g, '\\$&');
    var m = document.cookie.match(new RegExp('(?:^|; )' + escapedKey + '=([^;]*)'));

    return m ? decodeURIComponent(m[1]) : null;
  }

  function delCookie(key) {
    document.cookie = encodeURIComponent(key) + '=; max-age=0; path=/';
  }

  window.Store = {
    set: function (k, v) {
      if (STORAGE_BACKEND === 'storage') {
        storage.setItem(k, v);
      } else {
        setCookie(k, v);
      }
    },

    get: function (k) {
      if (STORAGE_BACKEND === 'storage') {
        return storage.getItem(k);
      } else {
        return getCookie(k);
      }
    },

    remove: function (k) {
      if (STORAGE_BACKEND === 'storage') {
        storage.removeItem(k);
      } else {
        delCookie(k);
      }
    }
  };
})();
// ---------------- cookie関連 end----------------


(function () {

  function buildReturnTo() {
    var currentPath = window.location.pathname + window.location.search;

    return CROSSPOINT_LOGIN_COMPLETE_PATH + '?redirect=' + encodeURIComponent(currentPath);
  }

  function isLoginUrl(url) {
    var hostname = url.hostname.toLowerCase();
    var isAllowedCustomerAccountHost = CROSSPOINT_CUSTOMER_ACCOUNT_HOSTS.some(function (allowedHost) {
      return hostname === String(allowedHost).toLowerCase();
    });

    // Storefront login URLs.
    if (url.origin === window.location.origin) {
      return (
        url.pathname === '/account' ||
        url.pathname === '/account/' ||
        url.pathname === '/account/login' ||
        url.pathname === '/account/login/' ||
        url.pathname === '/customer_authentication/login' ||
        url.pathname === '/customer_authentication/login/' ||
        url.pathname === '/customer_identity/login' ||
        url.pathname === '/customer_identity/login/'
      );
    }

    if (!isAllowedCustomerAccountHost) {
      return false;
    }

    // Shopify標準の新しい顧客アカウントURL。
    // 例: https://shopify.com/65272185039/account?locale=ja
    if (/^\/[0-9]+\/account\/?$/.test(url.pathname)) {
      return true;
    }

    // 顧客アカウント用の独自ドメインを設定した場合のログインURL。
    // 例: https://account.example.com/authentication/login
    if (
      url.pathname === '/authentication/login' ||
      url.pathname === '/authentication/login/'
    ) {
      return true;
    }

    return false;
  }

  function rewriteLoginLinks() {
    document.querySelectorAll('a[href]').forEach(function (link) {
      var rawHref = link.getAttribute('href');
      var url;

      if (!rawHref) return;
      if (rawHref.indexOf('javascript:') === 0) return;
      if (rawHref.indexOf('#') === 0) return;

      try {
        url = new URL(rawHref, window.location.origin);
      } catch (e) {
        return;
      }

      if (!isLoginUrl(url)) return;

      link.setAttribute(
        'href',
        '/customer_authentication/login?return_to=' + encodeURIComponent(buildReturnTo())
      );
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', rewriteLoginLinks);
  } else {
    rewriteLoginLinks();
  }
})();

illiJq(function () {

  

  

  illiJq(":input").blur(function () {
    var value = illiJq(this).val();
    if (value && illiJq.type(value) == "string") {
      var replacedValue = value.replace(/｡|ﾟ|№|℡|\\|Ⅰ|Ⅱ|Ⅲ|Ⅳ|Ⅴ|Ⅵ|Ⅶ|Ⅷ|Ⅸ|Ⅹ|ⅰ|ⅱ|ⅲ|ⅳ|ⅴ|ⅵ|ⅶ|ⅷ|ⅸ|ⅹ|∑|√|∟|∠|∥|∩|∪|∫|∮|∵|≒|≡|⊥|⊿|①|②|③|④|⑤|⑥|⑦|⑧|⑨|⑩|⑪|⑫|⑬|⑭|⑮|⑯|⑰|⑱|⑲|⑳|〝|〟|㈱|㈲|㈹|㊤|㊥|㊦|㊧|㊨|㌃|㌍|㌔|㌘|㌢|㌣|㌦|㌧|㌫|㌶|㌻|㍉|㍊|㍍|㍑|㍗|㍻|㍼|㍽|㍾|㎎|㎏|㎜|㎝|㎞|㎡|㏄|㏍|丨|￢|纊|褜|鍈|銈|蓜|俉|炻|昱|棈|鋹|曻|彅|仡|仼|伀|伃|伹|佖|侒|侊|侚|侔|俍|偀|倢|俿|倞|偆|偰|偂|傔|僴|僘|兊|兤|冝|冾|凬|刕|劜|劦|勀|勛|匀|匇|匤|卲|厓|厲|叝|﨎|咜|咊|咩|哿|喆|坙|坥|垬|埈|埇|﨏|塚|增|墲|夋|奓|奛|奝|奣|妤|妺|孖|寀|甯|寘|寬|尞|岦|岺|峵|崧|嵓|﨑|嵂|嵭|嶸|嶹|巐|弡|弴|彧|德|忞|恝|悅|悊|惞|惕|愠|惲|愑|愷|愰|憘|戓|抦|揵|摠|撝|擎|敎|昀|昕|昻|昉|昮|昞|昤|晥|晗|晙|晴|晳|暙|暠|暲|暿|曺|朎|朗|杦|枻|桒|柀|栁|桄|棏|﨓|楨|﨔|榘|槢|樰|橫|橆|橳|橾|櫢|櫤|毖|氿|汜|沆|汯|泚|洄|涇|浯|涖|涬|淏|淸|淲|淼|渹|湜|渧|渼|溿|澈|澵|濵|瀅|瀇|瀨|炅|炫|焏|焄|煜|煆|煇|凞|燁|燾|犱|犾|猤|猪|獷|玽|珉|珖|珣|珒|琇|珵|琦|琪|琩|琮|瑢|璉|璟|甁|畯|皂|皜|皞|皛|皦|益|睆|劯|砡|硎|硤|硺|礰|礼|神|祥|禔|福|禛|竑|竧|靖|竫|箞|精|絈|絜|綷|綠|緖|繒|罇|羡|羽|茁|荢|荿|菇|菶|葈|蒴|蕓|蕙|蕫|﨟|薰|蘒|﨡|蠇|裵|訒|訷|詹|誧|誾|諟|諸|諶|譓|譿|賰|賴|贒|赶|﨣|軏|﨤|逸|遧|郞|都|鄕|鄧|釚|釗|釞|釭|釮|釤|釥|鈆|鈐|鈊|鈺|鉀|鈼|鉎|鉙|鉑|鈹|鉧|銧|鉷|鉸|鋧|鋗|鋙|鋐|﨧|鋕|鋠|鋓|錥|錡|鋻|﨨|錞|鋿|錝|錂|鍰|鍗|鎤|鏆|鏞|鏸|鐱|鑅|鑈|閒|隆|﨩|隝|隯|霳|霻|靃|靍|靏|靑|靕|顗|顥|飯|飼|餧|館|馞|驎|髙|髜|魵|魲|鮏|鮱|鮻|鰀|鵰|鵫|鶴|鸙|黑|ｱ|ｲ|ｳ|ｴ|ｵ|ｶ|ｷ|ｸ|ｹ|ｺ|ｻ|ｼ|ｽ|ｾ|ｿ|ﾀ|ﾁ|ﾂ|ﾃ|ﾄ|ﾅ|ﾆ|ﾇ|ﾈ|ﾉﾊ|ﾋ|ﾌ|ﾍ|ﾎ|ﾏ|ﾐ|ﾑ|ﾒ|ﾓ|ﾔ|ﾕ|ﾖ|ﾗ|ﾘ|ﾙ|ﾚ|ﾛ|ﾜ|ｦ|ﾝｧ|ｨ|ｩ|ｪ|ｫ|ｬ|ｭ|ｮ|ｯ/g, "");
      replacedValue = replacedValue.replace(/−/g, "-").replace(/―/g, "-");
      illiJq(this).val(replacedValue);
    }
  });

  

  if (location.pathname.match(/\/account\/login/)) {
    

    illiJq('#customer_login').submit(function () {
      var syncEmail = illiJq('input[name="customer[email]"]').val();
      syncResult = sysncCustomer(syncEmail);
      return true;

    })

    

     //パスワードリセット予約
     illiJq('input[name="email"]').parent().parent().parent().submit(function(){
            var recoverEmail = illiJq('input[name="email"]').val();
            reserveResult = reservePwReset(recoverEmail);
            return true;//常にtrue
        })
    
    illiJq('#RecoverPasswordForm').find('form').submit(function () {
      var recoverEmail = illiJq('input[name="email"]').val();
      reserveResult = reservePw(recoverEmail);
      return true;

    })
  }

  

  if (location.pathname.match(/\/account\/reset\//)) {

    

    if (illiJq('input:hidden[name="form_type"]').val() == "customer") {
      

      illiJq('form').submit(function () {
        if (this.action.indexOf('reset') > 0) { 

          if (illiJq('input[name="customer[password]"]').val() == illiJq('input[name="customer[password_confirmation]"]').val()) { 

            if (illiJq('input[name="customer[password]"]').val().length >= 5) {
              excutePwReset(this)
            }
          }
        }
        return true;
      })
    }
  }

    if (location.pathname.match(/\/account\/activate\//)) {

    if (illiJq('input:hidden[name="form_type"]').val() == "customer") {
      
     illiJq('form').submit(function () {
        if (this.action.indexOf('activate') > 0) {
          if (illiJq('input[name="customer[password]"]').val() == illiJq('input[name="customer[password_confirmation]"]').val()) { 
            if (illiJq('input[name="customer[password]"]').val().length >= 5) {
              excutePwReset(this)
            }
          }
        }
        return true;
      })      
    }
  }

  

  if (location.pathname.match(/\/cart/)) {
    
    
    illiJq('form').submit(function () {
      if (!this.action.indexOf('cart')) {
        return true;
      }
      if (illiJq('#coordinationFlag').val() == "cancel") {
        return true;
      }
      var memberId = illiJq('#customerId').val();
      if (!memberId) { 

        return true
      }
      

      var cpMessage = getDisacountByCp()
      if (cpMessage) {
        return true;
      }
      else {
        return false;
      }
    })
  }

  

  if (
    location.pathname.match(/\/account\/register/) ||
    location.pathname.match(/\/pages\/member-edit/)
  ) {
    console.log(location.pathname)
    var cookieStatus = Store.get('cookieStatus')
    
    var cardNo = getParam('MEMBER_ID');
    var pinCd = getParam('PIN_CD');

    var isUpdateCustomer = false;
    var postUrlEl = document.getElementById("crosspoint-post-url");
    var postUrl = postUrlEl ? postUrlEl.value : "";
    if(postUrl == '/apps/crosspoint/check-update-member'){
      isUpdateCustomer = true;
       Store.set('cookieStatus', "COMPLETE");
    }
    if(cookieStatus=="COMPLETE"){
      Store.remove('cookieCardNo');
      Store.remove('cookiePinCd');
      Store.remove('cookieStatus');
    }
    if(cardNo && pinCd){
      if(isUpdateCustomer){
        openErrorMessageDialog("アプリからの登録に失敗しました。\nお手数ですがアプリにお戻り頂き、\n画面右上のアイコン＞設定＞オンラインストア会員でログインよりログインをお願いします。");
        illiJq('#RegisterForm-submit').remove();
        //window.close();
        return;
      }
      
      illiJq("#RegisterForm-cardNo").val(cardNo);
      Store.set('cookieCardNo', cardNo);
      illiJq("#RegisterForm-pinCd").val(pinCd);
      Store.set('cookiePinCd', pinCd);
    }
    //カードとpinが存在しない
    if ((cardNo == null || String(cardNo).trim() === '') && (pinCd == null || String(pinCd).trim() === '')) {
      //cookieには保持している場合
      if(Store.get('cookieCardNo')){
        illiJq("#RegisterForm-cardNo").val(Store.get('cookieCardNo'));
        illiJq("#RegisterForm-pinCd").val(Store.get('cookiePinCd'));
    }
    }

    

    var sexValue = illiJq(`${crosspointCustomerFormId}-sex-update`).val();
    if (sexValue) {
      illiJq('#RegisterForm-sex-3').prop('checked', false);
      illiJq(`#RegisterForm-sex-${sexValue}`).prop('checked', true);
    } else if (isUpdateCustomer) {
      illiJq('#RegisterForm-sex-3').prop('checked', true);
    }
    

    var prefnameValue = illiJq(`${crosspointCustomerFormId}-prefname-update`).val();
    if (prefnameValue != null) {
      illiJq(`${crosspointCustomerFormId}-prefname`).val(prefnameValue);
    }
    

    var phoneValue = illiJq(`${crosspointCustomerFormId}-phone-update`).val();
    if (phoneValue != null) {
      replacedPhone = phoneValue.replace('+81', '0')
      illiJq(`${crosspointCustomerFormId}-phone`).val(replacedPhone);
    }
    

    var postcard_dm_unnecessary_flgValue = illiJq(`${crosspointCustomerFormId}-postcard_dm_unnecessary_flg-update`).val();
    if (postcard_dm_unnecessary_flgValue == "1") {
      illiJq('input:checkbox[name="customer[postcard_dm_unnecessary_flg]"]').prop('checked', false);
    }
    

    var accepts_marketingValue = illiJq(`${crosspointCustomerFormId}-accepts_marketing-update`).val();
    if (accepts_marketingValue == "false") {
      illiJq('input:checkbox[name="customer[accepts_marketing]"]').prop('checked', false);
    }
    

    for (var n = 1; n <= 100; n++) {
      var updateCustomAttribute = illiJq(`${crosspointCustomerFormId}-customattribute${n}-update`); 

      

      if (updateCustomAttribute.length) {
        var dataType = updateCustomAttribute.data("type");
        var updateValue = updateCustomAttribute.val();
        

        if (dataType == "select") {
          illiJq(`${crosspointCustomerFormId}-customattribute${n}`).val(updateValue);
        }
        

        else if (dataType == "radio") {
          var attributes = illiJq(`${crosspointCustomerFormId}-customattribute${n}-wrap`).find("input[type=radio]"); 

          attributes.each(function () {
            if (illiJq(this).val() == updateValue) {
              illiJq(this).prop("checked", true);
            }
          });
        }
        

        else if (dataType == "checkbox") {
          var attributes = illiJq(`${crosspointCustomerFormId}-customattribute${n}-wrap`).find("input[type=checkbox]"); 

          attributes.each(function () {
            var inputElement = illiJq(this);
            if (updateValue.indexOf(",") !== -1) { 

              var updateArray = updateValue.split(",");
              for (var element of updateArray) {
                if (inputElement.val() == element) {
                  inputElement.prop("checked", true);
                }
              }
            } else { 

              if (inputElement.val() == updateValue) {
                inputElement.prop("checked", true);
              }
            }
          });
        }
      }
    }
    

    if (document.getElementById("year") != null && !illiJq("#year").data("cpBirthdayJsInit")) {
      illiJq("#year").data("cpBirthdayJsInit", true);
      var time = new Date();
      var year = time.getFullYear();
      var month = time.getMonth() + 1;
      var date = time.getDate();
      var selectedYear = document.getElementById("year").value;
      var selectedMonth = document.getElementById("month").value;
      var yearEl = document.getElementById("year");
      var birthdayPrefilled = yearEl.getAttribute("data-crosspoint-birthday") === "prefilled";
      
      if (!yearEl.disabled) {
        if (!birthdayPrefilled) {
          illiJq('#year').empty().append('<option value="">年</option>');
          for (var i = year; i >= 1900; i--) {
            illiJq('#year').append('<option value="' + i + '">' + i + '</option>');
          }
        }
      }
      if (!birthdayPrefilled && !yearEl.disabled) {
        illiJq('#month').empty().append('<option value="">月</option>');
        for (var j = 1; j <= 12; j++) {
          illiJq('#month').append('<option value="' + j + '">' + j + '</option>');
        }
        illiJq('#date').empty().append('<option value="">日</option>');
        for (var k = 1; k <= 31; k++) {
          illiJq('#date').append('<option value="' + k + '">' + k + '</option>');
        }
      }
      illiJq('#year').off('change.cpBirthday').on('change.cpBirthday', function () {
        selectedYear = illiJq('#year').val();
        if (selectedYear === "" || selectedYear == null) {
          return;
        }
        var last_month = 12;
        if (selectedYear == year) {
          last_month = month;
        }
        illiJq('#month').children('option').remove();
        illiJq('#month').append('<option value="">月</option>');
        for (var n = 1; n <= last_month; n++) {
          var nStr = n.toString();
          illiJq('#month').append('<option value="' + nStr + '">' + nStr + '</option>');
        }
      });
      illiJq('#year,#month').off('change.cpBirthdayDay').on('change.cpBirthdayDay', function () {
        selectedYear = illiJq('#year').val();
        selectedMonth = illiJq('#month').val();
        if ((selectedYear === "" || selectedYear == null) && (selectedMonth === "" || selectedMonth == null)) {
          return;
        }
        var lastDate;
        if (selectedYear == year && selectedMonth == month) {
          lastDate = date;
        } else {
          

          if (selectedMonth == 2) {
            if ((Math.floor(selectedYear % 4 == 0)) && (Math.floor(selectedYear % 100 != 0)) || (Math.floor(selectedYear % 400 == 0))) {
              lastDate = 29;
            } else {
              lastDate = 28;
            }
            

          } else if (selectedMonth == 4 || selectedMonth == 6 || selectedMonth == 9 || selectedMonth == 11) {
            lastDate = 30;
          } else {
            lastDate = 31;
          }
        }
        illiJq('#date').children('option').remove();
        illiJq('#date').append('<option value="">日</option>');
        for (var m = 1; m <= lastDate; m++) {
          var mStr = m.toString();
          illiJq('#date').append('<option value="' + mStr + '">' + mStr + '</option>');
        }
      });
    }
    

    illiJq(".checkbox-customattribute input[type=checkbox]").click(function () {

      

      var dataLimit = illiJq(this).data("limit");
      var attributeName = illiJq(this).attr('name');
      var checked = illiJq(`input[name='${attributeName}']:checked`);
      if (dataLimit != null) {
        var notChecked = illiJq(`input[name='${attributeName}']`).not(':checked')
        if (checked.length >= parseInt(dataLimit, 10)) {
          notChecked.attr("disabled", true);
        } else {
          notChecked.attr("disabled", false);
        }
      }
      

      if (attributeName != "customer[postcard_dm_unnecessary_flg]") {
        if (attributeName != "customer[accepts_marketing]") {
          var checkedItems = [];
          var attributeData = "";
          var hiddenName = attributeName.replace("[]", "");
          checked.each(function () {
            checkedItems.push(illiJq(this).val());
            attributeData = checkedItems.join(',');
          });
          document.getElementById(`${hiddenName}-hidden`).value = attributeData;
        }
      }
    });

    
    
    var CP_ZIP_LOOKUP_ENABLED = false;

    if (window.CP_ZIP_LOOKUP_ENABLED === true) {
      CP_ZIP_LOOKUP_ENABLED = true;
    }

    var cpZipLookupEnabledEl = document.getElementById('crosspoint-zip-lookup-enabled');
    if (cpZipLookupEnabledEl) {
      var cpZipLookupEnabledValue = String(cpZipLookupEnabledEl.value || '').toLowerCase();
      CP_ZIP_LOOKUP_ENABLED = (
        cpZipLookupEnabledValue === 'true' ||
        cpZipLookupEnabledValue === '1' ||
        cpZipLookupEnabledValue === 'on' ||
        cpZipLookupEnabledValue === 'yes'
      );
    }

    var cpPostcodeEl = illiJq(crosspointCustomerFormId + '-postcode');
    if (CP_ZIP_LOOKUP_ENABLED && cpPostcodeEl.length) {
      function cpNormalizeRegisterPostcode(val) {
        if (val == null || val === '') return '';
        var s = String(val);
        s = s.replace(/[－﹣−‐⁃‑‒–—﹘ーｰ-]/g, '');
        return s.replace(/\D/g, '');
      }

      function cpFillRegisterAddressFromZip(zip7) {
        if (!zip7 || zip7.length !== 7) return;
        if (cpPostcodeEl.data('cp-zip-lookup-ok') === zip7) return;

        illiJq.ajax({
          url: 'https://zipcloud.ibsnet.co.jp/api/search',
          data: { zipcode: zip7 },
          dataType: 'jsonp',
          timeout: 5000
        }).done(function (data) {
          if (!data || String(data.status) !== '200' || !data.results || !data.results.length) {
            return;
          }

          cpPostcodeEl.data('cp-zip-lookup-ok', zip7);

          var r = data.results[0];
          var pref = r.address1 || '';
          var addr2 = r.address2 || '';
          var addr3 = r.address3 || '';

          if (pref) {
            illiJq(crosspointCustomerFormId + '-prefname').val(pref);
          }
          if (addr2) {
            illiJq(crosspointCustomerFormId + '-city').val(addr2);
          }
          if (addr3) {
            illiJq(crosspointCustomerFormId + '-town').val(addr3);
          }
        }).fail(function () {
          if (window.console && console.warn) {
            console.warn('ZipCloud lookup failed.');
          }
        });
      }

      var cpZipLookupDebounce;

      cpPostcodeEl.on('blur.cpZipLookup', function () {
        clearTimeout(cpZipLookupDebounce);
        var z = cpNormalizeRegisterPostcode(illiJq(this).val());
        cpFillRegisterAddressFromZip(z);
      });

      cpPostcodeEl.on('input.cpZipLookup', function () {
        var self = illiJq(this);
        clearTimeout(cpZipLookupDebounce);

        var z = cpNormalizeRegisterPostcode(self.val());

        if (z.length !== 7) {
          self.removeData('cp-zip-lookup-ok');
          return;
        }

        cpZipLookupDebounce = setTimeout(function () {
          cpFillRegisterAddressFromZip(z);
        }, 450);
      });
    }

    

    illiJq(document).off("click.cpRegisterFormSubmit", "#RegisterForm-submit").on("click.cpRegisterFormSubmit", "#RegisterForm-submit", function submitExcute() {
      

      illiJq(".form__message").each(function () {
        illiJq(this).addClass("hide");
      });
      illiJq(".input--error").each(function () {
        illiJq(this).removeClass("input--error");
      });
      illiJq('#ajax-error-message').addClass("hide");
      illiJq('#RegisterForm-client-error-summary').addClass("hide");
      illiJq('#RegisterForm-client-error-summary .cp-register-error-summary__list').empty();

      

      var error = false;

      
      var inputEmail = illiJq(`${crosspointCustomerFormId}-email`).val();
      const regex = /^[a-zA-Z0-9_.+-]+@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/;
      if(inputEmail == ""){
        illiJq(`${crosspointCustomerFormId}-email`).addClass("input--error");
        illiJq(`${crosspointCustomerFormId}-email-error`).removeClass("hide");
        illiJq(`${crosspointCustomerFormId}-email-error-message`).html(`※必須項目`);
        error = true;
      }else if (!regex.test(inputEmail)) {
        illiJq(`${crosspointCustomerFormId}-email`).addClass("input--error");
        illiJq(`${crosspointCustomerFormId}-email-error`).removeClass("hide");
        illiJq(`${crosspointCustomerFormId}-email-error-message`).html(`入力内容に不備があります`);
        error = true;
      }
      
      

      illiJq(".require").each(function () {
        var value = illiJq(this).val();
        if (value == null) {
          value = "";
        } else if (typeof value !== "string") {
          value = String(value);
        }
        var targetId = illiJq(this).attr('id');
        var errorMessageBlock = `#${targetId}-error`;
        var errorMessage = `#${targetId}-error-message`;
        var dataType = illiJq(this).data("type");
        

        if (dataType == "checkbox" || dataType == "radio") {
          var attributeNameList = targetId.split("-");
          var checkboxId = `${crosspointCustomerFormId}-${attributeNameList[1]}`;
          var attributeName = illiJq(this).attr('name');
          var checkboxErrorMessageLabel = `${checkboxId}-wrap`;
          var checkboxErrorMessageBlock = `${checkboxId}-error`;
          var checkboxErrorMessage = `${checkboxId}-error-message`;
          var checkedItems;
          var dataMinimum = illiJq(this).data("minimum");
          illiJq(this).each(function () {
            checkedItems = illiJq(`input[name='${attributeName}']:checked`).length;
          });
          illiJq(checkboxErrorMessageLabel).removeClass("label--error");
          illiJq(checkboxErrorMessageBlock).addClass("hide");
          if (dataMinimum != null) {
            if (checkedItems < parseInt(dataMinimum, 10)) {
              illiJq(checkboxErrorMessageLabel).addClass("label--error");
              illiJq(checkboxErrorMessageBlock).removeClass("hide");
              illiJq(checkboxErrorMessage).html(dataMinimum + "つ以上選択してください");
              error = true;
            }
          } else if (checkedItems === 0) {
            illiJq(checkboxErrorMessageLabel).addClass("label--error");
            illiJq(checkboxErrorMessageBlock).removeClass("hide");
            illiJq(checkboxErrorMessage).html("※必須項目");
            error = true;
          }
          

        } else if (dataType == "select") {
          illiJq(this).removeClass("input--error");
          illiJq(errorMessageBlock).addClass("hide");
          if (value == "" || value == "選択してください") {
            illiJq(this).addClass("input--error");
            illiJq(errorMessageBlock).removeClass("hide");
            illiJq(errorMessage).html("※必須項目");
            error = true;
          }
        } else {
          illiJq(this).removeClass("input--error");
          illiJq(errorMessageBlock).addClass("hide");
          if (value == "" || !value.match(/[^\s\t]/)) {
            illiJq(this).addClass("input--error");
            illiJq(errorMessageBlock).removeClass("hide");
            illiJq(errorMessage).html("※必須項目");
            error = true;
          }
        }
      });

      
      if (illiJq("#year").length) {
        var y = illiJq("#year").val();
        var m = illiJq("#month").val();
        var d = illiJq("#date").val();
        if (y == "" || m == "" || d == "") {
          illiJq("#year, #month, #date").addClass("input--error");
          illiJq(`${crosspointCustomerFormId}-birthday-error`).removeClass("hide");
          illiJq(`${crosspointCustomerFormId}-birthday-error-message`).html("※必須項目");
          error = true;
        } else {
          illiJq("#year, #month, #date").removeClass("input--error");
        }
      }

      

      var passwordMinLength = 5; 

      var passwordValue = illiJq(`${crosspointCustomerFormId}-password`).val();
      if (passwordValue && passwordValue.length < passwordMinLength) {
        illiJq(`${crosspointCustomerFormId}-password`).addClass("input--error");
        illiJq(`${crosspointCustomerFormId}-password-error`).removeClass("hide");
        illiJq(`${crosspointCustomerFormId}-password-error-message`).html(`${String(passwordMinLength)}桁以上で入力してください`);
        error = true;
      }

      

      illiJq(".date-attribute").each(function () {
        var value = illiJq(this).val();
        if (value == null) {
          value = "";
        }
        if (typeof value !== "string") {
          value = String(value);
        }
        var targetId = illiJq(this).attr('id');
        var errorMessageBlock = `#${targetId}-error`;
        var errorMessage = `#${targetId}-error-message`;
        var dataform = illiJq(this).data("form");
        if (value != "" || value.match(/[^\s\t]/)) {
          illiJq(this).removeClass("input--error");
          illiJq(errorMessageBlock).addClass("hide");
          if (dataform == "day") {
            if (!checkDate(value)) {
              illiJq(this).addClass("input--error");
              illiJq(errorMessageBlock).removeClass("hide");
              illiJq(errorMessage).html("正しい年月日形式（例：2021/01/01）で入力してください");
              error = true;
            }
          } else if (dataform == "month") {
            if (!checkMonth(value)) {
              illiJq(this).addClass("input--error");
              illiJq(errorMessageBlock).removeClass("hide");
              illiJq(errorMessage).html("正しい年月形式（例：2021/01）で入力してください");
              error = true;
            }
          }
        }
      });

      
      if (illiJq(`${crosspointCustomerFormId}-agreement`).length > 0){
        if (!(illiJq(`${crosspointCustomerFormId}-agreement`).prop("checked"))){
          illiJq(`${crosspointCustomerFormId}-agreement`).addClass("input--error");
          illiJq(`${crosspointCustomerFormId}-agreement-error`).removeClass("hide");
          illiJq(`${crosspointCustomerFormId}-agreement-error-message`).html("※必須項目");
          error = true;
        }
      }
      

      if (error) {
        cpRegisterShowClientErrorSummaryPanel();
        return false;
      }

      

      illiJq(this).addClass("btn-disable");
      illiJq(".loader").removeClass("hide");

      

      crosspointCheckCustomerApp();
      return true;
    });

    
    illiJq("#agreement-text").on('click',  function () {
      if(illiJq(this).data('agreement') == "modal"){ //埋め込みの場合
        illiJq("body").attr('style', 'overflow: hidden');
        illiJq(".modal-overlay").fadeIn(); 
        illiJq(".agreement-modal").fadeIn(); 
      }else{ //別ページへ遷移の場合
        window.open(illiJq(this).data('url'), '_blank');
      }
    });
    
    illiJq('.modal-close, .modal-overlay').on('click', function () {
      illiJq("body").attr('style', 'overflow:');
      illiJq(".modal-overlay").fadeOut();
      illiJq(".agreement-modal").fadeOut();
    });
    
    illiJq(`${crosspointCustomerFormId}-agreement-modal`).on('change', function () {
      
      illiJq(`${crosspointCustomerFormId}-agreement`).prop("checked", illiJq(this).prop("checked"));
      illiJq("body").attr('style', 'overflow:');
      illiJq(".modal-overlay").fadeOut();
      illiJq(".agreement-modal").fadeOut();
    });
    
    if (illiJq(`${crosspointCustomerFormId}-agreement-modal`).length > 0){
      illiJq(`${crosspointCustomerFormId}-agreement`).on('change', function () {
        
        illiJq(`${crosspointCustomerFormId}-agreement-modal`).prop("checked", illiJq(this).prop("checked"));
      });
    }

    
    if (illiJq("#RegisterForm").length) {
      illiJq("#RegisterForm").on("focusout.cpRegister", "input:not([type=hidden]):not([type=submit]):not([type=button]), select, textarea", function () {
        cpRegisterFieldValidate(this);
      });
      illiJq("#RegisterForm").on("change.cpRegister", "input[type=checkbox], input[type=radio], select", function () {
        cpRegisterFieldValidate(this);
      });
    }
  }

  

  if (
    /^\/account\/?$/.test(location.pathname) ||
    /^\/pages\/mypage\/?$/.test(location.pathname)
  ) {
    Store.set('cookieStatus', "COMPLETE");//登録ステータスを完了にセット
  }

  if (location.pathname.match(/\/account\/addresses/)) {

    

    illiJq("#address_form_new-submit").click(function () {
      var ajaxErrorId = "#address_form_new-ajax-error-message";

      

      illiJq(".form__message").each(function () {
        illiJq(this).addClass("hide");
      });
      illiJq(".input--error").each(function () {
        illiJq(this).removeClass("input--error");
      });
      illiJq(ajaxErrorId).addClass("hide");

      

      illiJq(this).addClass("btn-disable");

      

      crosspointCheckAddressApp("#address_form_new", ajaxErrorId);
      return true;
    });

    

    illiJq(".address_form_edit-submit").click(function () {
      var form = illiJq(this).data("address");
      var formId = `#${form}`;
      var ajaxErrorId = `${formId}-ajax-error-message`;

      

      illiJq(".form__message").each(function () {
        illiJq(this).addClass("hide");
      });
      illiJq(".input--error").each(function () {
        illiJq(this).removeClass("input--error");
      });
      illiJq(ajaxErrorId).addClass("hide");

      

      illiJq(this).addClass("btn-disable");

      

      crosspointCheckAddressApp(formId, ajaxErrorId);
      return true;
    });
  }
});



function cpRegisterValidateEmail() {
  var inputEmail = illiJq(crosspointCustomerFormId + "-email").val();
  var regex = /^[a-zA-Z0-9_.+-]+@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/;
  if (inputEmail == "") {
    illiJq(crosspointCustomerFormId + "-email").addClass("input--error");
    illiJq(crosspointCustomerFormId + "-email-error").removeClass("hide");
    illiJq(crosspointCustomerFormId + "-email-error-message").html("※必須項目");
    return false;
  }
  if (!regex.test(inputEmail)) {
    illiJq(crosspointCustomerFormId + "-email").addClass("input--error");
    illiJq(crosspointCustomerFormId + "-email-error").removeClass("hide");
    illiJq(crosspointCustomerFormId + "-email-error-message").html("入力内容に不備があります");
    return false;
  }
  illiJq(crosspointCustomerFormId + "-email").removeClass("input--error");
  illiJq(crosspointCustomerFormId + "-email-error").addClass("hide");
  return true;
}

function cpRegisterValidateBirthday() {
  if (!illiJq("#year").length) return true;
  var y = illiJq("#year").val();
  var m = illiJq("#month").val();
  var d = illiJq("#date").val();
  if (y == "" || m == "" || d == "") {
    illiJq("#year, #month, #date").addClass("input--error");
    illiJq(crosspointCustomerFormId + "-birthday-error").removeClass("hide");
    illiJq(crosspointCustomerFormId + "-birthday-error-message").html("※必須項目");
    return false;
  }
  illiJq("#year, #month, #date").removeClass("input--error");
  illiJq(crosspointCustomerFormId + "-birthday-error").addClass("hide");
  return true;
}

function cpRegisterValidateAddress() {
  if (illiJq('input:hidden[name="customer[addressRequiredSetting]"]').val() != "notRequired") return true;
  var keys = ["postcode", "prefname", "city", "town"];
  illiJq.each(keys, function (index, value) {
    illiJq(crosspointCustomerFormId + "-" + value).removeClass("input--error");
    illiJq(crosspointCustomerFormId + "-" + value + "-error").addClass("hide");
  });
  return true;
}

function cpRegisterValidateDateAttribute($t) {
  var value = $t.val();
  var targetId = $t.attr("id");
  if (!targetId) return true;
  var errorMessageBlock = "#" + targetId + "-error";
  var errorMessage = "#" + targetId + "-error-message";
  var dataform = $t.data("form");
  if (!value || !value.match(/[^\s\t]/)) {
    $t.removeClass("input--error");
    illiJq(errorMessageBlock).addClass("hide");
    return true;
  }
  $t.removeClass("input--error");
  illiJq(errorMessageBlock).addClass("hide");
  if (dataform == "day" && !checkDate(value)) {
    $t.addClass("input--error");
    illiJq(errorMessageBlock).removeClass("hide");
    illiJq(errorMessage).html("正しい年月日形式（例：2021/01/01）で入力してください");
    return false;
  }
  if (dataform == "month" && !checkMonth(value)) {
    $t.addClass("input--error");
    illiJq(errorMessageBlock).removeClass("hide");
    illiJq(errorMessage).html("正しい年月形式（例：2021/01）で入力してください");
    return false;
  }
  return true;
}

function cpRegisterValidateAgreement() {
  if (!illiJq(crosspointCustomerFormId + "-agreement").length) return true;
  if (illiJq(crosspointCustomerFormId + "-agreement").prop("checked")) {
    illiJq(crosspointCustomerFormId + "-agreement").removeClass("input--error");
    illiJq(crosspointCustomerFormId + "-agreement-error").addClass("hide");
    return true;
  }
  illiJq(crosspointCustomerFormId + "-agreement").addClass("input--error");
  illiJq(crosspointCustomerFormId + "-agreement-error").removeClass("hide");
  illiJq(crosspointCustomerFormId + "-agreement-error-message").html("※必須項目");
  return false;
}

function cpRegisterValidateOneRequire($t) {
  if (!$t || !$t.length) return true;
  if (!$t.hasClass("require")) return true;
  if ($t[0].disabled) return true;
  var value = $t.val();
  if (value == null) {
    value = "";
  } else if (typeof value !== "string") {
    value = String(value);
  }
  var targetId = $t.attr("id");
  if (!targetId) return true;
  var errorMessageBlock = "#" + targetId + "-error";
  var errorMessage = "#" + targetId + "-error-message";
  var dataType = $t.data("type");
  if (dataType == "checkbox" || dataType == "radio") {
    var attributeNameList = targetId.split("-");
    var checkboxId = crosspointCustomerFormId + "-" + attributeNameList[1];
    var attributeName = $t.attr("name");
    var checkboxErrorMessageLabel = checkboxId + "-wrap";
    var checkboxErrorMessageBlock = checkboxId + "-error";
    var checkboxErrorMessage = checkboxId + "-error-message";
    var checkedItems = illiJq("input[name='" + attributeName + "']:checked").length;
    var dataMinimum = $t.data("minimum");
    illiJq(checkboxErrorMessageLabel).removeClass("label--error");
    illiJq(checkboxErrorMessageBlock).addClass("hide");
    if (dataMinimum != null) {
      if (checkedItems < parseInt(dataMinimum, 10)) {
        illiJq(checkboxErrorMessageLabel).addClass("label--error");
        illiJq(checkboxErrorMessageBlock).removeClass("hide");
        illiJq(checkboxErrorMessage).html(dataMinimum + "つ以上選択してください");
        return false;
      }
    } else if (checkedItems === 0) {
      illiJq(checkboxErrorMessageLabel).addClass("label--error");
      illiJq(checkboxErrorMessageBlock).removeClass("hide");
      illiJq(checkboxErrorMessage).html("※必須項目");
      return false;
    }
  } else if (dataType == "select") {
    illiJq($t).removeClass("input--error");
    illiJq(errorMessageBlock).addClass("hide");
    if (value == "" || value == "選択してください") {
      illiJq($t).addClass("input--error");
      illiJq(errorMessageBlock).removeClass("hide");
      illiJq(errorMessage).html("※必須項目");
      return false;
    }
  } else {
    illiJq($t).removeClass("input--error");
    illiJq(errorMessageBlock).addClass("hide");
    if (value == "" || !value.match(/[^\s\t]/)) {
      illiJq($t).addClass("input--error");
      illiJq(errorMessageBlock).removeClass("hide");
      illiJq(errorMessage).html("※必須項目");
      return false;
    }
    if (targetId === "RegisterForm-password" && value.length < 5) {
      illiJq($t).addClass("input--error");
      illiJq(errorMessageBlock).removeClass("hide");
      illiJq(errorMessage).html("5桁以上で入力してください");
      return false;
    }
  }
  return true;
}

function cpRegisterFieldValidate(el) {
  if (!el || el.nodeType !== 1) return;
  if (!illiJq(el).closest("#RegisterForm").length) return;
  if (el.type === "hidden" || el.type === "button" || el.type === "submit") return;
  if (el.disabled) return;
  var $t = illiJq(el);
  var id = el.id;

  if (id === "RegisterForm-email" || (el.getAttribute("name") === "customer[email]" && el.type === "email")) {
    cpRegisterValidateEmail();
    return;
  }
  if (id === "year" || id === "month" || id === "date") {
    cpRegisterValidateBirthday();
    return;
  }
  if (/^RegisterForm-(postcode|prefname|city|town|building)$/.test(id)) {
    cpRegisterValidateAddress();
    return;
  }
  if ($t.hasClass("date-attribute")) {
    cpRegisterValidateDateAttribute($t);
    return;
  }
  if (id === "RegisterForm-agreement") {
    cpRegisterValidateAgreement();
    return;
  }
  if (el.type === "radio" && el.name) {
    var $reqR = illiJq("#RegisterForm input[type=radio]").filter(function () {
      return this.name === el.name && illiJq(this).hasClass("require");
    });
    if ($reqR.length) {
      cpRegisterValidateOneRequire(illiJq($reqR[0]));
      return;
    }
  }
  if (el.type === "checkbox" && el.name) {
    var $reqC = illiJq("#RegisterForm input").filter(function () {
      return this.name === el.name && illiJq(this).hasClass("require");
    });
    if ($reqC.length) {
      cpRegisterValidateOneRequire(illiJq($reqC.get($reqC.length - 1)));
      return;
    }
  }
  if ($t.hasClass("require")) {
    cpRegisterValidateOneRequire($t);
  }
}


function cpRegisterLabelTextForErrorBlock(blockId) {
  if (!blockId || blockId.slice(-6) !== "-error") {
    return "";
  }
  if (blockId === "RegisterForm-birthday-error") {
    var $by = illiJq('#RegisterForm label[for="year"]');
    return $by.length
      ? $by.clone().find(".asterisk").remove().end().text().replace(/\s+/g, " ").trim()
      : "生年月日";
  }
  if (blockId === "RegisterForm-sex-error") {
    var $sx = illiJq("#RegisterForm-sex-wrap").children("label").first();
    return $sx.length
      ? $sx.clone().find(".asterisk").remove().end().text().replace(/\s+/g, " ").trim()
      : "性別";
  }
  var base = blockId.replace(/-error$/, "");
  var $lab = illiJq('#RegisterForm label[for="' + base + '"]');
  if ($lab.length) {
    return $lab.first().clone().find(".asterisk").remove().end().text().replace(/\s+/g, " ").trim();
  }
  return base.replace(/^RegisterForm-/, "").replace(/-/g, " ");
}


function cpRegisterFillClientErrorSummary() {
  var $wrap = illiJq("#RegisterForm-client-error-summary");
  var $ul = $wrap.find(".cp-register-error-summary__list");
  if (!$wrap.length || !$ul.length) {
    return;
  }
  $ul.empty();
  illiJq("#RegisterForm .form__message")
    .not(".hide")
    .each(function () {
      var $block = illiJq(this);
      if ($block.is("h2")) {
        return;
      }
      var bid = $block.attr("id");
      if (!bid || !/^RegisterForm-.+-error$/.test(bid)) {
        return;
      }
      var $msg = $block.find('[id$="-error-message"]').first();
      if (!$msg.length) {
        $msg = $block.find(".label--error").first();
      }
      var msgText = ($msg.text() || "").trim();
      if (!msgText) {
        return;
      }
      var fieldName = cpRegisterLabelTextForErrorBlock(bid);
      var $li = illiJq("<li/>");
      $li.append(document.createTextNode("・"));
      $li.append(illiJq('<span class="cp-register-error-summary__field"/>').text(fieldName));
      $li.append(document.createTextNode(" "));
      $li.append(illiJq('<span class="cp-register-error-summary__msg"/>').text(msgText));
      $ul.append($li);
    });
}

function cpRegisterShowClientErrorSummaryPanel() {
  cpRegisterFillClientErrorSummary();
  var $wrap = illiJq("#RegisterForm-client-error-summary");
  if (!$wrap.length) {
    return;
  }
  if ($wrap.find(".cp-register-error-summary__list li").length === 0) {
    $wrap.addClass("hide");
    illiJq("#ajax-error-message").removeClass("hide");
    illiJq("#ajax-error-message").html("申し訳ございませんが、ご入力いただいた内容に不備がございます。");
    return;
  }
  $wrap.removeClass("hide");
  illiJq("#ajax-error-message").addClass("hide");
  var el = document.getElementById("RegisterForm-client-error-summary");
  if (el && el.scrollIntoView) {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}



function sysncCustomer(syncEmail) {
  var syncResult = illiJq.ajax({
    type: "POST",
    async: false,
    url: "/apps/crosspoint/login-sync",
    

    data: { email: syncEmail },
    success: function (data, dataType) {
      return data;
    },
    

    error: function () {
      return false;
    }
  }).responseText
}



function reservePwReset(recoberemail) {
  var reserveResult = illiJq.ajax({
    type: "POST",
    async: false,
    url: "/apps/crosspoint/pw-reset-reserve",
    data: { recoberemail: recoberemail },
    success: function (data, dataType) {
      return data;
    },
    

    error: function () {
      return false;
    }
  }).responseText
}



function excutePwReset(form) {
  var hostUrl = '/apps/crosspoint/pw-reset-excute'
  illiJq.ajax({
    url: hostUrl,
    type: 'POST',
    dataType: 'json',
    data: illiJq(form).serialize(),
    timeout: 3000,
    async: false,
    cache: false
  }).done(function (data) {
    if (data.result) {
      if (data.status == 'success') {
        return true;
      } else {
        return true;
      }
    }
  }).fail(function (XMLHttpRequest, textStatus, errorThrown) {
    return true;
  })
}



function getDisacountByCp() {
  var hostUrl = '/apps/crosspoint/get-coupon';
  var cart = getCart();
  var memberId = illiJq('#customerId').val();
  var shopIncludeTax = illiJq('#shopIncludeTax').val()
  var usePoint = illiJq("#usePoint").val();
  var apiResul = false;
  var ajaxResult = illiJq.ajax({
    url: hostUrl,
    type: 'POST',
    dataType: 'json',
    data: {
      cart: cart,
      memberId: memberId,
      shopIncludeTax: shopIncludeTax,
      usePoint: usePoint
    },
    timeout: 30000,
    async: false,
  }).done(function (data) {
    if (data.result) {
      if (data.status == 'success') {
        if(data.result.discountCode){	
          // illiJq('#quantityDiscount').val(data.result.discountCode)
          setUseCoupon(data.result.discountCode)
        }else{	
          // illiJq('#quantityDiscount').val(data.result)	
          setUseCoupon(data.result)	
        }
        apiResul = true;
      } else {
        openErrorMessageDialog(data.result);
        apiResul = false;
      }
    } else if (data.status == 'skip') {
      apiResul = true;
    }
  }).fail(function (XMLHttpRequest, textStatus, errorThrown) {
    openErrorMessageDialog("通信エラーが発生しました。時間をあけて再度お試しください");
  })
  return apiResul;
}



function crosspointCheckCustomerApp() {
  
  illiJq(window).on('beforeunload', function(e) {
    e.preventDefault();
    return '';
  });

  

  illiJq('#year').prop("disabled", false);
  illiJq('#month').prop("disabled", false);
  illiJq('#date').prop("disabled", false);
  var postUrlEl = document.getElementById("crosspoint-post-url");
  var postUrl = postUrlEl ? postUrlEl.value : "";
  if (!postUrl) {
    illiJq('#ajax-error-message').removeClass("hide");
    illiJq('#ajax-error-message').html("会員登録フォームの設定が見つかりません。ページを再読み込みするか、管理者にお問い合わせください。");
    enableButton();
    illiJq(window).off('beforeunload');
    return;
  }
  

  illiJq.ajax({
    url: postUrl,
    type: 'POST',
    dataType: 'json',
    data: illiJq('#RegisterForm').serialize(),
    timeout: 30000,
  })
    .then(
      function (res) {
        if (res.result) {
          if (res.status == 'success') {
            var cpTokenInput = document.getElementById("RegisterForm-cpToken");
            if (res.update) {
              if (cpTokenInput) {
                cpTokenInput.value = res.result;
              }
              crosspointUpdateCutomerApp(); 

            } else {
              var memberIdParam = getParam('MEMBER_ID');
              var pinCdParam   = getParam('PIN_CD');
              const cardNoInput  = illiJq('#RegisterForm-cardNo').val();
              if (!cpTokenInput) {
                illiJq('#ajax-error-message').removeClass("hide");
                illiJq('#ajax-error-message').html("フォームの初期化に失敗しました。ページを再読み込みしてください。");
                enableButton();
                return;
              }
              //if(getParam('MEMBER_ID') && getParam('PIN_CD')){
              if ( (memberIdParam && pinCdParam) || (cardNoInput && cardNoInput.startsWith('9')) ) {
                cpTokenInput.value = res.result+'isFromApp';
              }else{
                cpTokenInput.value = res.result;
              }
              var registerFormEl = document.getElementById("RegisterForm");
              if (registerFormEl) {
                registerFormEl.submit(); 
              }

            }
          } else {
            if (res.result == "shopifyApiError") { 

              illiJq('#RegisterForm-client-error-summary').addClass("hide");
              illiJq('#RegisterForm-client-error-summary .cp-register-error-summary__list').empty();
              illiJq('#ajax-error-message').removeClass("hide");
              illiJq('#ajax-error-message').html("通信エラーが発生しました。もう一度お試しください。");
            } else {
              setErrorMsg(res.result, crosspointCustomerFormId); 

              cpRegisterShowClientErrorSummaryPanel();
            }
            enableButton(); 


            if (res.update) {
              disableBirthDay(); 

            }
          }
        } else {
          illiJq('#RegisterForm-client-error-summary').addClass("hide");
          illiJq('#RegisterForm-client-error-summary .cp-register-error-summary__list').empty();
          illiJq('#ajax-error-message').removeClass("hide");
          illiJq('#ajax-error-message').html("サーバーから想定外の応答がありました。時間をあけて再度お試しください。");
          enableButton();
        }
      },
      function () {
        illiJq('#RegisterForm-client-error-summary').addClass("hide");
        illiJq('#RegisterForm-client-error-summary .cp-register-error-summary__list').empty();
        illiJq('#ajax-error-message').removeClass("hide");
        illiJq('#ajax-error-message').html("サーバーへの接続に失敗しました。時間をあけて再度お試しください。");
        enableButton(); 

        if (postUrl == '/apps/crosspoint/check-update-member') {
          disableBirthDay(); 

        }
      }
    )
    .always(function () {
      
      illiJq(window).off('beforeunload');
    });
}



function crosspointUpdateCutomerApp() {
  illiJq.ajax({
    url: '/apps/crosspoint/update-member',
    type: 'POST',
    dataType: 'json',
    data: {
      id: illiJq(`${crosspointCustomerFormId}-customerId`).val(),
      cpToken: illiJq(`${crosspointCustomerFormId}-cpToken`).val()
    },
    timeout: 30000,
  })
    .then(
      function (res) {
        if (res.status == 'success') {
          var completeUrlEl = document.getElementById("crosspoint-update-complete-url");
          var completeUrl = completeUrlEl && completeUrlEl.value ? completeUrlEl.value : "/pages/mypage";
          window.location.href = completeUrl; 

        } else {
          illiJq('#ajax-error-message').removeClass("hide");
          illiJq('#ajax-error-message').html("会員情報の更新に失敗いたしました。申し訳ございませんが、時間をあけて再度お試しください。");
          enableButton(); 

          disableBirthDay(); 

        }
      },
      function () {
        illiJq('#ajax-error-message').removeClass("hide");
        illiJq('#ajax-error-message').html("サーバーへの接続に失敗しました。時間をあけて再度お試しください。");
        enableButton(); 

        disableBirthDay(); 

      }
    );
}



function crosspointCheckAddressApp(formId, ajaxErrorId) {
  
  illiJq(window).on('beforeunload', function(e) {
    e.preventDefault();
    return '';
  });

  

  var addressForm = illiJq(formId);
  if (formId == "#address_form_new") { 

    var last_name = "#AddressLastNameNew";
    var first_name = "#AddressFirstNameNew";
    var company = "#AddressCompanyNew";
    var zip = "#AddressZipNew";
    var country = "#AddressCountryNew";
    var province = "#AddressProvinceNew";
    var city = "#AddressCityNew";
    var address1 = "#AddressAddress1New";
    var address2 = "#AddressAddress2New";
    var phone = "#AddressPhoneNew";
    var buttonId = "#address_form_new-submit";
  } else { 

    var inputId = formId.replace("#address_form_", "");
    var last_name = `#AddressLastName_${inputId}`;
    var first_name = `#AddressFirstName_${inputId}`;
    var company = `#AddressCompany_${inputId}`;
    var zip = `#AddressZip_${inputId}`;
    var country = `#AddressCountry_${inputId}`;
    var province = `#AddressProvince_${inputId}`;
    var city = `#AddressCity_${inputId}`;
    var address1 = `#AddressAddress1_${inputId}`;
    var address2 = `#AddressAddress2_${inputId}`;
    var phone = `#AddressPhone_${inputId}`;
    var buttonId = `#submit_${inputId}`;
  }
  

  illiJq(country).prop("disabled", false);
  

  illiJq.ajax({
    url: '/apps/crosspoint/check-update-address',
    type: 'POST',
    dataType: 'json',
    data: {
      address: {
        last_name: illiJq(last_name).val(),
        first_name: illiJq(first_name).val(),
        company: illiJq(company).val(),
        zip: illiJq(zip).val(),
        country: illiJq(country).val(),
        province: illiJq(province).val(),
        city: illiJq(city).val(),
        address1: illiJq(address1).val(),
        address2: illiJq(address2).val(),
        phone: illiJq(phone).val()
      }
    },
    timeout: 30000,
  })
    .then(
      function (res) {
        if (res.status == 'success') {
          addressForm.submit();
        } else {
          setErrorMsg(res.result, formId); 

          illiJq(ajaxErrorId).removeClass("hide");
          illiJq(ajaxErrorId).html("申し訳ございませんが、ご入力いただいた内容に不備がございます。");
          illiJq(buttonId).removeClass("btn-disable"); 

          illiJq(country).prop("disabled", true); 

          return false;
        }
      },
      function () {
        illiJq(ajaxErrorId).removeClass("hide");
        illiJq(ajaxErrorId).html("サーバーへの接続に失敗しました。時間をあけて再度お試しください。");
        illiJq(buttonId).removeClass("btn-disable"); 

        illiJq(country).prop("disabled", true); 

        return false;
      }
    )
    .always(function () {
      
      illiJq(window).off('beforeunload');
    });
}



function getCart() {
  var result = illiJq.ajax({
    url: '/cart.js',
    dataType: 'json',
    async: false
  }).responseText;
  return result;
}



function isNumber(val) {
  var regexp = new RegExp(/^[0-9]+(\.[0-9]+)?$/);
  return regexp.test(val);
}



function setErrorMsg(messages, formId) {
  for (key in messages) {
    

    if (formId == crosspointCustomerFormId) {
      var targetId = `${formId}-${key}`;
      

    } else if (formId == "#address_form_new") {
      var upperInitialKey = key.charAt(0).toUpperCase() + key.slice(1);
      var targetId = `#Address${upperInitialKey}New`;
      

    } else {
      var inputId = formId.replace("#address_form_", "");
      var upperInitialKey = key.charAt(0).toUpperCase() + key.slice(1);
      var targetId = `#Address${upperInitialKey}_${inputId}`;
    }
    if (key == "birthday") { 

      illiJq("#year").addClass("input--error");
      illiJq("#month").addClass("input--error");
      illiJq("#date").addClass("input--error");
    } else {
      illiJq(targetId).addClass("input--error");
    }
    illiJq(`${formId}-${key}-error`).removeClass("hide");
    illiJq(`${formId}-${key}-error-message`).html(messages[key]);
  }
}



function disableBirthDay() {
  var yearRegisterValue = illiJq(`${crosspointCustomerFormId}-birthday-update`).val();
  if (yearRegisterValue) {
    illiJq('#year').prop("disabled", true);
    illiJq('#month').prop("disabled", true);
    illiJq('#date').prop("disabled", true);
  }
}



function enableButton() {
  illiJq(`${crosspointCustomerFormId}-submit`).removeClass("btn-disable");
  illiJq(".loader").addClass("hide");
}



function checkDate(value) {
  

  if (value == null || typeof value !== "string") {
    return false;
  }
  if (!value.match(/^[0-9]{4}\/(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])$/)) {
    return false;
  }
  

  var dateString = value.match(/^(\d+)\/(\d+)\/(\d+)$/);
  if (dateString) {
    var year = parseInt(dateString[1]);
    var month = parseInt(dateString[2]) - 1;
    var day = parseInt(dateString[3]);
    var collectDate = new Date(year, month, day);
    return (year == collectDate.getFullYear() && month == collectDate.getMonth() && day == collectDate.getDate());
  }
  return false;
}



function checkMonth(value) {
  

  if (value == null || typeof value !== "string") {
    return false;
  }
  if (!value.match(/^[0-9]{4}\/(0[1-9]|1[0-2])$/)) {
    return false;
  }
  

  var dateString = value.match(/^(\d+)\/(\d+)$/);
  if (dateString) {
    var year = parseInt(dateString[1]);
    var month = parseInt(dateString[2]) - 1;
    var collectDate = new Date(year, month);
    return (year == collectDate.getFullYear() && month == collectDate.getMonth());
  }
  return false;
}


function getParam(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}


function setUseCoupon(code){
  var ajaxResult = illiJq.ajax({
    url: '/discount/'+code,
    type:'GET',
    timeout:30000,
    async : false,
    cache: false,
  }).done(function(data) {
    apiResul = true;
  }).fail(function(XMLHttpRequest, textStatus, errorThrown) {
    alert("通信エラーが発生しました。時間をあけて再度お試しください");
  })
  return apiResul;
}


